<template lang="pug">
nav.navbar.navbar-primary.navbar-transparent-.navbar-absolute(:class='tabsClass.value' v-if='!featureFlags.legacyViewDisabled')
  //ed-meta-nav
  .container-fluid
    .navbar-header
      button.navbar-toggle(type='button', data-toggle='collapse', @click='toggleSideBar')
        span.sr-only Toggle navigation
        span.icon-bar
        span.icon-bar
        span.icon-bar
      a.navbar-brand.logo(href='#/home')
        img(src='~images/../logo.svg', height='35' v-if='!config.namespace')
        p(v-if='config.title') {{ $t(config.title) }}
    .collapse.navbar-collapse.text-right
      site-map(:reference='reference', :className='tabsClass')
      //navbar-right(v-if='!config.namespace')
      //navbar-search
</template>
<script>
import featureFlags from '@/core/feature-flags/feature-flags'
import SiteMap from '@/core/site-map'

import NavbarSearch from './navbar-search'
import NavbarRight from './navbar-right'

export default {
  props: ['reference'],
  data() {
    return {
      featureFlags,
      config: global.config,
      tabsClass: { value: '' }
    }
  },
  computed: {
    checkLogin() {
      return this.$store.state.isLoggedIn
    }
  },
  components: {
    SiteMap,
    NavbarSearch,
    NavbarRight
  },
  methods: {
    toggleSideBar() {
      this.$emit('toggleSideBar')
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.navbar-toggle {
  .icon-bar {
    @include theme(true) {
    background: v(ink);
    border-color: v(ink);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Navigation/index.vue